import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/App";
import reportWebVitals from "@/reportWebVitals";
import "@/index.css";
import "@/App.css";
import "@/assets/styles/global.css";
import "animate.css";
import { setupInterceptors } from "@/utils/setupInterceptors";
import AppErrorBoundary from "@/components/AppErrorBoundary";
import { installChunkErrorHandler } from "@/bootstrap/install-chunk-error-handler";
import { installGlobalPanicHandlers } from "@/bootstrap/install-global-panic-handlers";
import { installBeforeInstallPromptCapture } from "@/bootstrap/install-before-install-prompt-capture";
import {
  bootstrapThemeSafely,
  clearPanicRoot,
  installDevThemeResetHelper,
  renderMinimalFallbackShell,
} from "@/theme/startup-safe-render";

setupInterceptors();
installDevThemeResetHelper();
installGlobalPanicHandlers();
installChunkErrorHandler();
// Chromium fires `beforeinstallprompt` once per page load, usually before the lazy My Orders
// route exists. Capture is registered here so the event is not lost; it suppresses nothing
// unless the install offer is actually eligible.
installBeforeInstallPromptCapture();

const rootEl = document.getElementById("root");
const bootstrap = bootstrapThemeSafely();

if (!bootstrap.ok || !rootEl) {
  renderMinimalFallbackShell();
} else {
  clearPanicRoot();
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </React.StrictMode>,
  );
}

reportWebVitals();
